<template>
  <div class="restaurant-card-wrapper">
    <div
      v-show="!(screenType === 'laptop' || screenType === 'tablet')"
      class="restaurant-card-column"
    >
      <template v-if="screenType === 'laptop' || screenType === 'tablet'">
        <perfect-scrollbar class="restaurant-card-images_laptop">
          <Skeleton
            v-for="photo in 3"
            :key="photo"
            width="340px"
            height="240px"
          />
        </perfect-scrollbar>
      </template>

      <div class="restaurant-card-images" v-else>
        <Skeleton width="340px" height="240px" />
        <Skeleton v-for="photo in 3" :key="photo" width="108px" height="80px" />
      </div>

      <div class="restaurant-card-review-container">
        <div class="restaurant-card-review">
          <div :style="{ display: 'flex', gap: '8px' }">
            <Skeleton width="32px" height="32px" round />
            <Skeleton height="32px" />
          </div>
          <Skeleton height="48px" />
        </div>
        <Skeleton height="32px" width="100px" />
      </div>
    </div>
    <div class="restaurant-card-column">
      <div class="restaurant-card-header">
        <Skeleton width="56px" height="56px" round />
        <Skeleton height="64px" />
      </div>
      <perfect-scrollbar class="restaurant-card-pills">
        <Skeleton
          v-for="feature in 7"
          :key="feature"
          width="110px"
          height="28px"
        />
      </perfect-scrollbar>
      <Skeleton height="60px" />

      <div :style="{ display: 'flex', gap: '24px' }">
        <div class="restaurant-card-sub-column _left">
          <div
            :style="{ display: 'flex', gap: '12px', flexDirection: 'column' }"
          >
            <Skeleton height="24px" width="108px" />
            <Skeleton height="172px" />
          </div>

          <div :style="{ display: 'flex', gap: '24px' }">
            <Skeleton height="52px" width="116px" />
            <Skeleton height="52px" width="116px" />
          </div>
          <Skeleton height="40px" width="180px" />
        </div>
        <div class="restaurant-card-sub-column _right">
          <Skeleton height="120px"></Skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import Skeleton from "@/components/ui/Skeleton.vue";

export default {
  name: "RestaurantCardSkeleton",
  components: {
    Skeleton,
    PerfectScrollbar,
  },

  computed: {
    screenType() {
      return this.$store.getters.screenType;
    },
  },
};
</script>

<style lang="scss" scoped>
.restaurant-card {
  &-wrapper {
    display: flex;
    gap: 24px;
    width: 100%;
    padding: 16px 24px 24px 16px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 0 8px 0 #00000014;

    @include laptop {
      flex-direction: column-reverse;
    }
  }

  &-column {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &:first-child {
      width: 340px;

      @include laptop {
        width: 100%;
      }
    }

    &:last-child {
      width: 100%;
    }
  }

  &-sub-column {
    display: flex;
    flex-direction: column;
    width: 50%;

    &._left {
      gap: 24px;
    }

    &._right {
      gap: 8px;

      font-size: 16px;
      line-height: 22px;

      .restaurant-card-icon-row {
        display: flex;
        align-items: center;
        gap: 8px;

        &._schedule {
          cursor: pointer;
          .details-tablo {
            margin-left: 4px;
          }
        }

        &._link {
          overflow: hidden;
          white-space: nowrap;

          a {
            display: inline-block;
            max-width: 30ch;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
          }
        }
      }
    }
  }

  &-header {
    display: flex;
    align-items: center;
    gap: 16px;

    div:first-child {
      flex: 0 0 auto;
    }
  }

  &-header-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &-images {
    display: grid;
    grid-gap: 16px 8px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    width: 340px;
    height: 336px;
    border-radius: 8px;
    background-color: #fff;

    div {
      object-fit: cover;
      border-radius: 8px;
      cursor: pointer;
    }

    div:nth-child(1) {
      height: 240px;
      width: 100%;

      grid-column: 1 / 4;
      grid-row: 1;
    }

    div:nth-child(2) {
      height: 80px;
      width: 108px;

      grid-column: 1;
      grid-row: 2;
    }

    div:nth-child(3) {
      height: 80px;
      width: 108px;
      grid-column: 2;
      grid-row: 2;
    }

    div:nth-child(4) {
      height: 80px;
      width: 108px;

      grid-column: 3;
      grid-row: 2;
    }

    .image_default {
      background-color: #ebebeb;
      background-size: 100px 100px;
      background-repeat: no-repeat;
      filter: grayscale(1);
      cursor: auto;
    }
  }

  &-images_laptop {
    display: flex;
    gap: 8px;
    flex-wrap: nowrap;
    padding-bottom: 12px;
  }

  &-image_laptop {
    width: 340px;
    height: 240px;
    border-radius: 8px;
  }

  &-book-button {
    width: 180px;
  }

  &-features {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    span {
      margin-bottom: 12px;

      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
    }
  }

  &-top-actions {
    display: flex;
    margin-left: auto;
    align-items: center;
    gap: 16px;
  }

  &-schedule-wrapper {
    display: flex;
    gap: 24px;
  }

  &-schedule {
    display: flex;
    flex-direction: column;
    gap: 6px;
    &-label {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
    }
    &-value {
      display: flex;
      align-items: center;
      gap: 4px;

      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
    }
  }

  &-stars {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
  }

  &-favorite-btn {
    width: 26px;
    height: 24px;
    cursor: pointer;
  }

  &-review-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  &-review {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    div:first-child {
      flex: 0 0 auto;
    }
  }

  &-description-text {
    max-width: 1124px;
    width: 100%;
    font-weight: 400;
    word-wrap: break-word;
    overflow: auto;
    font-size: 14px;
    line-height: 20px;

    &._short {
      cursor: pointer;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      position: relative;
      line-height: 20px;
      max-height: calc(20px * 3);

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 20px;
        width: 100%;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
        pointer-events: none;
      }
    }
  }
}

.restaurant-info {
  display: flex;
  gap: 12px;

  &-item {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #858585;
  }

  &-value {
    font-weight: 600;
    color: #222222;
  }
}
</style>
